import { get } from '@/httpRequest'

export interface ISessionListUsersRequest {
  page?: number
  size?: number
}

export interface ISessionListUsersResponse {
  count: number
  list: ISessionListUsersItem[]
}

export interface ISessionListUsersItem {
  created_at?: number
  deleted_at?: null
  id?: string
  last_read_at?: number
  session_avatar_url?: string
  session_id?: string
  session_name?: string
  session_type?: number
  updated_at?: number
  preFix?: string
}

export const getSessionListUsers = async (params: ISessionListUsersRequest) => {
  const response = await get<ISessionListUsersResponse>(
    `/imApi/session/listUsers`,
    params
  )

  return response
}
